<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row >
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <br />
          <v-img
            src="@/assets/Learning.jpg"
            class="mx-auto"
            width="200px;"
          />
          <div>
            <p class="pt-2">
            The Maritech LMS is a comprehensive platform that enables admin
            users to create courses, assessments, and learning groups for crews.
            This system is mobile responsive, which means it can be accessed
            from any device, including smartphones and tablets.
          </p>
            <ul class="imageCls">
              <li>
                <b>Unlocking Efficiency with AI:</b> Our LMS harnesses the
                cutting-edge capabilities of Artificial Intelligence to
                personalize learning experiences, automate administrative tasks,
                and provide intelligent insights for optimized learning
                outcomes.
              </li>
              <li>
                <b>Adaptive Learning Paths:</b> Using AI algorithms, our system
                adapts to individual learner needs, creating customized learning
                paths that maximize engagement and knowledge retention.
              </li>
              <li>
                <b>Smart Analytics and Reporting:</b> Utilize AI-driven
                analytics to gain deeper insights into learner progress,
                identify patterns, and generate comprehensive reports for
                informed decision-making.
              </li>
              <li>
                <b>Instant Support at Your Fingertips:</b> Our platform comes
                equipped with a robust live help system, ensuring learners and
                administrators have immediate access to real-time assistance.
                From technical queries to course guidance, our live help feature
                guarantees timely and efficient support.
              </li>
              <li>
                <b>Seamless Collaboration and Assistance:</b> Foster a
                collaborative learning environment with our integrated live help
                system, enabling learners to seek guidance, troubleshoot issues,
                and engage in live discussions—all within the platform.
              </li>
              <li>
                <b>Expert Guidance on Demand:</b> Connect directly with our
                dedicated support team or subject matter experts through the
                live help system, ensuring that every learner receives the
                assistance they need, precisely when they need it.
              </li>
            </ul>
          </div>
          <br />
          <p><strong>Features</strong></p>
          <div>
            <ul class="imageCls">
              <li>
                Create courses: The system allows admin users to create custom
                courses on various topics related to cyber security. These
                courses can be tailored to suit the specific needs of the
                maritime industry.
              </li>
              <br />
              <li>
                Create MCQ based assessments: The system allows admin users to
                create multiple choice questions (MCQ) based assessments to test
                the knowledge of learners. These assessments can be used to
                evaluate the progress of learners and identify areas where they
                may need additional support.
              </li>
            </ul>
          </div>
          <ul class="imageCls">
            <li>
              Learning groups: The system allows admin users to create learning
              groups and assign specific courses or assessments to them. This
              makes it easy to manage and track the progress of learners.
            </li>
            <br />
            <li>
              Built-in survey: Each course includes a built-in survey that
              allows learners to provide feedback on the material. This helps
              admin users understand how well the course was received and
              identify areas for improvement.
            </li>
            <li>
              Management reports: The system provides various management reports
              that allow admin users to assess the progress of learners and
              track their performance. These reports can be used to identify
              areas where additional support may be needed.
            </li>
            <br />
            <li>
              Auto reminders: The system sends automatic reminders to learners
              to ensure that they are keeping up with their coursework and
              assessments
            </li>
            <li>
              Certificate of completion: Upon completion of a course, learners
              can download a certificate of completion that verifies their
              achievemen
            </li>
          </ul>
          <br />

          <p class="pt-3 pb-3"><strong>Customization</strong></p>
          <p>
            The Maritech LMS can be customized to suit the specific needs of the
            maritime industry. This includes customizing the courses and
            assessments to align with industry-specific requirements and
            regulations. <br /><br />
            Overall, the Maritech LMS is an effective tool for helping
            organizations ensure that their employees or students have the
            knowledge and skills they need to protect against cyber threats. It
            is an essential resource for any organization looking to strengthen
            its cyber security posture.
          </p>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>

    <div class="text-center pt-5">
      <strong>
        "A one-size-fits-all approach is not effective for either shoes or
        software. Both need to be tailored to the individual user or business to
        be truly effective."</strong
      >
    </div>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Maritech LMS";
  }
};
</script>
<style scoped>
p {
  text-align: justify;
}
.rowclr {
  background-color: rgb(239, 239, 239);
}
.imageCls {
  text-align: justify;
}
h2 {
  font-size: 35px;
}
h1 {
  font-size: 30px;
  color: rgb(3, 50, 97);
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
